import {InjectionToken, Signal} from '@angular/core';

/** Подписи календаря. Месяцы идут с января, дни недели — с понедельника. */
export interface CalendarLocale {
  readonly months: readonly string[];
  readonly weekdays: readonly string[];
  readonly weekdayLabels: readonly string[];
  readonly previousMonth: string;
  readonly nextMonth: string;
  readonly previousYear: string;
  readonly nextYear: string;
  readonly previousYears: string;
  readonly nextYears: string;
}

export const CALENDAR_LOCALE_RU: CalendarLocale = {
  months: [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
  ],
  weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  weekdayLabels: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
  previousMonth: 'Предыдущий месяц',
  nextMonth: 'Следующий месяц',
  previousYear: 'Предыдущий год',
  nextYear: 'Следующий год',
  previousYears: 'Предыдущие годы',
  nextYears: 'Следующие годы',
};

export const CALENDAR_LOCALE_EN: CalendarLocale = {
  months: [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ],
  weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  weekdayLabels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  previousYear: 'Previous year',
  nextYear: 'Next year',
  previousYears: 'Previous years',
  nextYears: 'Next years',
};

/** Локаль по умолчанию; переопределяется провайдером без зависимости от сервиса переводов приложения. */
export const AUR_CALENDAR_LOCALE = new InjectionToken<CalendarLocale | Signal<CalendarLocale>>('AUR_CALENDAR_LOCALE', {
  providedIn: 'root',
  factory: () => CALENDAR_LOCALE_RU,
});
